<script lang="ts">
	import toCloudinaryUrl from '$lib/utils/toCloudinarUrl';

	export let hubLogoUrl: string;
	export let hubLogoHeight: number;
	$: cloudinaryUrl = toCloudinaryUrl(hubLogoUrl, 420, hubLogoHeight || 90, 'contain');
</script>

<img src={cloudinaryUrl} alt="Hub logo" />

<style>
	img {
		block-size: auto;
		max-inline-size: 100%;
		margin-block-end: var(--gutterLarge);
	}
</style>
